// Use this composable if you want to delay the loading of a component or feature until
// after a set time on the client. Use it in combination with a lazy loaded component.
const useDelayClientLoad = (loadAfter: number) => {
  const isAppInteractive = useIsAppInteractive();
  const isLoaded = ref(false);

  watchEffect(async () => {
    if (!isAppInteractive.value) return;

    await sleep(loadAfter);
    isLoaded.value = true;
  });

  return isLoaded;
};

export default useDelayClientLoad;
